import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default  {
  namespaced: true,
  state: {
    //список бонусов
    bonuses:[],
    //список типов партнера
    partnerTypes:[],
      bonusPackages:[],


  },
  actions,
  mutations,
  getters
}
